import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { Query } from './Query';
import { IQueryOptionsGlobal } from '../models/query/options';

export class GlobalQuery extends BaseQuery<IQueryOptionsGlobal> {
	initialize(executionOptions: IExecutionOptions) {
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsGlobal {
		const { key, keyQuery, options = {} } = this.queryOptions;
		return {
			key,
			keyQuery,
			...(options.global || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions, callStackLevel: number = 1): T {
		const { key } = this.options;
		const context = Query.getContext(executionOptions, this.queryOptions);
		if (key && context) {
			const { globalQueries } = context;
			if (globalQueries && Array.isArray(globalQueries)) {
				const globalQuery = globalQueries.find(globalQuery => globalQuery.queryId === key);
				if (globalQuery) {
					const query = new Query(globalQuery, this.translationHelper, callStackLevel + 1);
					return query.execute(executionOptions);
				}
			}
		}
		return;
	}
}